<!--患者管理-->
<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input v-model="query.patientName"
                              placeholder="请输入患者姓名"
                              style="width: 200px;margin-right: 20px"
                              suffix-icon="el-icon-search"
                              size="small">
                    </el-input>
                    <el-input v-model="query.mobile"
                              placeholder="请输入患者手机号"
                              suffix-icon="el-icon-search"
                              style="width: 200px;"
                              size="small">
                    </el-input>
                </div>
                <div>
                    <el-button @click="openExe" style="width: 96px">导出表格</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '2%'}"
                          :cell-style="{'padding-left': '2%'}">
                    <el-table-column prop="realName" label="患者"></el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
                    <el-table-column prop="sex" label="性别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex === '1'">男</span>
                            <span v-if="scope.row.sex === '2'">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <!--                  <el-button type="text" @click="editPatient(scope.row)">查看编辑</el-button>-->
                            <el-button type="text" @click="seeRecord(scope.row)">就诊记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑患者" :visible.sync="editVisible" width="530px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form ref="edit" :rules="rule" :model="patientEdit" label-width="80px" size="small">
                <div class="dialog-set">
                    <el-form-item label="姓名" prop="patientName">
                        <el-input v-model="patientEdit.patientName" style="width: 100px"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" label-width="65px" prop="sex">
                        <el-select v-model="patientEdit.sex" style="width: 90px">
                            <el-option key="1" label="男" value="1"></el-option>
                            <el-option key="0" label="女" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="年龄" label-width="64px" prop="age">
                        <el-input v-model="patientEdit.age" style="width: 90px"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="patientEdit.mobile" style="width: 410px"></el-input>
                </el-form-item>
                <div class="dialog-set">
                    <el-form-item label="证件类型" prop="certificateType">
                        <el-select v-model="patientEdit.certificateType" placeholder="证件类型" class="handle-select">
                            <el-option key="1" label="身份证" value="1"></el-option>
                            <!--                            <el-option key="2" label="护照" value="2"></el-option>-->
                            <!--                            <el-option key="3" label="台胞证" value="3"></el-option>-->
                            <!--                            <el-option key="4" label="港澳通行证" value="4"></el-option>-->
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="idNo" label-width="0">
                        <el-input v-model="patientEdit.idNo" style="width: 290px"></el-input>
                    </el-form-item>
                </div>
                <div class="dialog-set">
                    <el-form-item label="省市区" prop="province">
                        <el-select v-model="patientEdit.province" placeholder="选择省"
                                   @change="chooseProvince" style="width: 140px;">
                            <el-option v-for="item in province" :key="item.provinceId"
                                       :label="item.province" :value="item.provinceId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="city" label-width="0">
                        <el-select v-model="patientEdit.city" placeholder="选择市"
                                   @change="chooseCity" style="width: 135px">
                            <el-option v-for="item in city" :key="item.cityId"
                                       :label="item.city" :value="item.cityId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="district" label-width="0">
                        <el-select v-model="patientEdit.district" placeholder="选择区/县"
                                   style="width: 135px;">
                            <el-option v-for="item in area" :key="item.areaId"
                                       :label="item.area" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="patientEdit.address" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="过敏史">
                    <el-input v-model="patientEdit.allergy" style="width: 410px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="选择导出条数" :visible.sync="openExeVisible" width="530px"
                   :close-on-click-modal="false" >
            打印条数:<el-input v-model.number="exePagesize"   @keydown="handleInput" onkeyup="this.value=this.value.replace(/[^0-9.]/g,'')"> </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openExeVisible=false" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="outExe" style="width: 76px">确定</el-button>
            </span>
        </el-dialog>
        <el-drawer size="900px" title="就诊记录" :visible.sync="seeVisible" direction="rtl" :before-close="closeSee">
            <div class="record">
                <div class="record-aside" v-infinite-scroll="load" :infinite-scroll-immediate="false">
                    <div class="patient-box"
                         v-for="(item,index) in seeDoctorData"
                         :key="index"
                         @click="selectPatient(item)"
                         :class="{active : active === item.orderNo}"
                    >
                        <div>
                            <span v-if="item.gmtCreated">就诊日期:{{ item.gmtCreated.slice(0,10) }}</span>
                        </div>
                        <div>
                            <span>临床诊断:{{ item.doctorDiagnose }}</span>
                        </div>
                    </div>
                </div>
                <el-scrollbar style="height:100%">
                    <div class="record-main" v-if="patientRecord.list.length">
                        <div class="flex-box mb10" style="justify-content: space-between;width: 510px">
                            <div>
                                <span style="width: 80px" class="mr20">姓名: {{ seeDoctorData[0].userName }}</span>
                                <span class="mr20">共{{patientRecord.quantityTotal}}剂</span>
                                <span class="mr20">总价:<span class="money">¥{{patientRecord.totalAmt}}</span></span>
                            </div>
                        </div>
                        <el-table :data="patientRecord.list">
                            <el-table-column prop="productName" width="250px" label="药材名称"></el-table-column>
                            <el-table-column prop="quantityTotal" label="剂量"></el-table-column>
                        </el-table>
                    </div>
                </el-scrollbar>
                <div class="dialog-foot-bottom">
                    <el-button type="primary" @click="closeSee" style="width: 76px">确 定</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script type="module">
    export default {
        data() {
            return {
                // token
                authorization: localStorage.getItem('authorization'),
                // 搜索数据
                query: {
                    patientName: '',
                    mobile: '',
                },
                // 列表数据
                tableData: [],
                pageNum: 1,
                pageSize: 10,
                total: 0,

                province: [],
                city: [],
                area: [],
                editVisible: false,
                insertVisible: false,
                rule: {
                    patientName: [{required: true, message: '请输入患者姓名', trigger: 'blur'}],
                    sex: [{required: true, message: '请选择性别', trigger: 'change'}],
                    age: [{required: true, message: '请输入年龄', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^[1][3-9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur'}],
                    certificateType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
                    idNo: [{required: true, message: '请输入证件号码', trigger: 'blur'}],
                    // province: [{required: true, message: '请选择省', trigger: 'change'}],
                    // city: [{required: true, message: '请选择市', trigger: 'change'}],
                    // district: [{required: true, message: '请选择区', trigger: 'change'}],
                    // address: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
                },
                patientAdd: {
                    patientName: '',
                    sex: '',
                    age: '',
                    mobile: '',
                    certificateType: '1',
                    idNo: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                    allergy: '',
                },
                patientEdit: {
                    patientId: '',
                    patientName: '',
                    sex: '',
                    age: '',
                    mobile: '',
                    certificateType: '',
                    idNo: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                    allergy: '',
                },
                patient: {},
                patientId: '',
                recordPageNum: 1,
                recordPageSize: 15,
                recordTotal: 0,
                seeVisible: false,
                seeDoctorData: [],
                patientRecord: {
                    list: {}
                },
                active: '',
                exePagesize:10,
                exePageNum:1,
                openExeVisible:false

            };
        },
        created() {
            this.getData();
        },
        methods: {
            openExe(){
                this.openExeVisible=true;
            },
        handleInput(e) {
            let a = e.key.replace(/^[+]{0,1}(\d+)$/, "");
            if (!a) {
                e.preventDefault();
            }
        },
            // 获取列表数据
            getData() {
                this.axios.get('/api-b/10026/100012/' + this.pageNum + "/" + this.pageSize
                    + '?patientName=' + this.query.patientName + '&mobile=' + this.query.mobile, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then((res) => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            let data = res.data.data;
                            this.tableData = data.list;
                            this.total = data.total;
                        } else {
                            this.$message.info('暂无患者');
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                })
            },
            // 分页导航
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 导出Excel
            outExe() {
                this.axios.get('/api-b/10026/100083?patientName=' + this.query.patientName + '&mobile='
                    + this.query.mobile+'&pageSize='+this.exePagesize+'&pageNum='+this.exePageNum, {
                    headers: {
                        Authorization: this.authorization,
                    },
                    responseType: "blob"
                }).then(res => {
                    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
                    let filename = '患者列表.xlsx'
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        window.navigator.msSaveBlob(blob, filename)
                    } else {
                        var blobURL = window.URL.createObjectURL(blob)// 将blob对象转为一个URL
                        var tempLink = document.createElement('a')// 创建一个a标签
                        tempLink.style.display = 'none'
                        tempLink.href = blobURL
                        tempLink.setAttribute('download', filename)// 给a标签添加下载属性
                        if (typeof tempLink.download === 'undefined') {
                            tempLink.setAttribute('target', '_blank')
                        }
                        document.body.appendChild(tempLink)// 将a标签添加到body当中
                        tempLink.click()// 启动下载
                        document.body.removeChild(tempLink)// 下载完毕删除a标签
                        window.URL.revokeObjectURL(blobURL)
                    }
                })
            },
            // 获取省列表
            getProvince() {
                this.axios.get('/api-b/10028/100071', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.province = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开新增弹窗
            handleAdd() {
                // 获取省列表
                this.getProvince()
                this.insertVisible = true
            },
            // 选择省
            chooseProvince(val) {
                this.axios.get('/api-b/10028/100072?father=' + val, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.city = res.data.data
                        this.area = []
                        this.patientAdd.city = ''
                        this.patientAdd.district = ''
                        this.patientEdit.city = ''
                        this.patientEdit.district = ''
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择市
            chooseCity(val) {
                this.axios.get('/api-b/10028/100073?father=' + val, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.area = res.data.data
                        this.patientAdd.district = ''
                        this.patientEdit.district = ''
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 取消新增后消除验证
            cancelAdd() {
                this.insertVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 新增患者
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {
                            patientName: this.patientAdd.patientName,
                            mobile: this.patientAdd.mobile,
                            sex: this.patientAdd.sex,
                            age: this.patientAdd.age,
                            certificateType: this.patientAdd.certificateType,
                            idNo: this.patientAdd.idNo,
                            province: this.patientAdd.province,
                            city: this.patientAdd.city,
                            district: this.patientAdd.district,
                            address: this.patientAdd.address,
                            allergy: this.patientAdd.allergy
                        }
                        this.axios.post('/api-b/10026/100009', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.insertVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        this.$refs.add.resetFields();
                                        this.city = []
                                        this.area = []
                                    }, 300)
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            // 取消修改
            cancelEdit() {
                this.editVisible = false
                this.city = []
                this.area = []
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 获取市
            getCity(index) {
                this.axios.get('/api-b/10028/100072?father=' + index, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.city = res.data.data
                    }
                })
            },
            // 获取区
            getArea(index) {
                this.axios.get('/api-b/10028/100073?father=' + index, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.area = res.data.data
                    }
                })
            },
            // 编辑弹窗
            editPatient(data) {
                this.getProvince()
                let params = new FormData()
                params.append('patientId', data.patientId)
                this.axios.post('/api-b/10026/100062', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.editVisible = true
                        this.patientEdit = res.data.data
                        this.getCity(this.patientEdit.province)
                        this.getArea(this.patientEdit.city)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认编辑
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        let params = {
                            patientId: this.patientEdit.patientId,
                            patientName: this.patientEdit.patientName,
                            mobile: this.patientEdit.mobile,
                            sex: this.patientEdit.sex,
                            age: this.patientEdit.age,
                            certificateType: this.patientEdit.certificateType,
                            idNo: this.patientEdit.idNo,
                            province: this.patientEdit.province,
                            city: this.patientEdit.city,
                            district: this.patientEdit.district,
                            address: this.patientEdit.address,
                            allergy: this.patientEdit.allergy
                        }
                        this.axios.post('/api-b/10026/100010', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.getData()
                                this.cancelEdit()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            // 获取就诊记录
            getRecord() {
                let data = this.patient
                this.patientId = data.id
                this.axios.get('/api-b/10026/100063/' + this.recordPageNum + "/" + this.recordPageSize
                    + '?patientId=' + this.patientId, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if(res.data.data.list.length>0){
                            this.recordPageNum++
                            this.seeVisible = true
                            this.recordTotal = res.data.data.total
                            this.seeDoctorData = res.data.data.list
                            this.patientRecord.totalAmt = this.seeDoctorData[0].totalAmt
                        }else {
                            this.$message.info("暂无数据")
                        }
                        //this.getRecordData(this.seeDoctorData[0].orderNo)
                    } else {
                        this.$message.info(res.data.message)
                    }
                })
            },
            // 查看就诊记录
            seeRecord(data) {
                this.patient = data
                this.patientId = data.id
                this.axios.get('/api-b/10026/100063/' + this.recordPageNum + "/" + this.recordPageSize
                    + '?patientId=' + this.patientId, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                       if(res.data.data.list.length>0){
                        this.recordPageNum++
                        this.seeVisible = true
                        this.recordTotal = res.data.data.total
                        this.seeDoctorData = res.data.data.list
                        this.patientRecord.totalAmt = this.seeDoctorData[0].totalAmt

                        this.getRecordData(this.seeDoctorData[0].orderNo)
                       }else {
                           this.$message.info("暂无数据")
                       }
                    } else {
                        this.$message.info(res.data.message)
                    }
                })
            },
            // 就诊记录下拉获取下一页
            load() {
                if (this.recordPageNum <= parseInt(this.recordTotal / this.recordPageSize) + 1) {
                    this.getRecord()
                }
            },
            // 关闭就诊记录
            closeSee() {
                this.seeVisible = false
                this.recordPageNum = 1
            },
            // 获取就诊记录详细信息
            getRecordData(data) {
                this.patientRecord.list={}
                this.patientRecord.quantityTotal=0
                this.axios.get('/api-b/10026/100064?orderNo=' + data, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.patientRecord.list = res.data.data.list
                        this.patientRecord.quantityTotal = res.data.data.quantityTotal

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择记录
            selectPatient(data) {
                this.active = data.orderNo
                this.getRecordData(data.orderNo)
            },
        },
        watch: {
            // 监听搜索框值变化,请求列表数据
            query: {
                handler() {
                    clearTimeout(this.timeout);
                    this.pageNum = 1
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            },
        }
    };
</script>

<style>
    :focus {
        outline: none;
    }

    .el-drawer__header > :first-child {
        margin-top: -20px;
    }

    .el-drawer__header {
        height: 34px;
        background: rgba(97, 167, 255, 1);
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-drawer__close-btn {
        margin-top: -20px;
        color: #FFFFFF;
        font-size: 14px;
    }

    .scrollbar-wrap {
        overflow-x: hidden;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .handle-select {
        width: 120px;
    }

    .record {
        display: flex;
        flex-direction: row;
        height: 861px;
        border: 1px solid rgba(227, 227, 227, 1);
    }

    .record-aside {
        transform: translate3d(0, 0, 0);
        overflow: auto;
        padding: 10px;
        min-height: 825px;
        width: 276px;
        background: rgba(246, 246, 246, 1);
    }

    .patient-box {
        padding: 10px 0 10px 10px;
        background: rgba(242, 242, 242, 1);
        border-radius: 4px;
        border: 1px solid rgba(227, 227, 227, 1);
        font-size: 14px;
        margin: 10px 0 0;
        color: rgba(102, 102, 102, 1);
    }

    .flex-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
    }

    .active {
        background: rgba(240, 246, 255, 1);
        border: 1px solid rgba(97, 167, 255, 1);
    }

    .record-main {
        transform: translate3d(0, 0, 0);
        overflow: auto;
        width: 580px;
        padding: 10px;
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 13px;
        right: 20px;
    }

    .mr60 {
        margin-left: 60px;
    }

    .mb10 {
        margin-bottom: 10px;
    }

    .mr20 {
        margin-right: 20px;
    }

    .money {
        font-size: 16px;
        color: rgba(255, 148, 89, 1);
    }
</style>
